import FormValidations from 'data/FormValidations';
import every from 'lodash/every';
import {
  getMessage,
  ACTIVE,
  CHANGE,
  DESACTIVE,
  MODIFY,
  REMIND,
  SET_PIN,
  VALID_EMAIL,
  MODAL_SUCCESS,
  MODAL_ERROR,
  emptyValidation,
  invalidPin,
  isNotChecked,
  noMatchValidation,
} from './constants';

export const scapeXMLcontent = data => {
  const myRegexp = /<!\[CDATA\[(.*)]]>/;
  const match = myRegexp.exec(data);
  if (match != null && match.length > 1) {
    return match[1];
  }
  return data;
};

export const hasErrors = (typeForm, form, translations) => {
  const errors = {};
  if (typeForm === ACTIVE) {
    Object.assign(
      errors,
      new FormValidations(form.pin_code, 'pin_code')
        .isValidPin(invalidPin(translations))
        .getErrors(),
    );
    if (every([form.pin_purchase, form.pin_parental], value => !value)) {
      errors.pin_purchase = isNotChecked(translations);
      errors.pin_parental = isNotChecked(translations);
    }
  }
  if (typeForm === CHANGE) {
    Object.assign(
      errors,
      new FormValidations(form.current_pin, 'current_pin')
        .isValidPin(invalidPin(translations))
        .getErrors(),
    );

    Object.assign(
      errors,
      new FormValidations(form.new_pin, 'new_pin')
        .isValidPin(invalidPin(translations))
        .getErrors(),
    );

    Object.assign(
      errors,
      new FormValidations(form.repeat_pin, 'repeat_pin')
        .isValidPin(invalidPin(translations))
        .getErrors(),
    );

    Object.assign(
      errors,
      new FormValidations(form.new_pin, 'new_pin')
        .isEqual(form.repeat_pin, noMatchValidation(translations))
        .getErrors(),
    );

    Object.assign(
      errors,
      new FormValidations(form.repeat_pin, 'repeat_pin')
        .isEqual(form.new_pin, noMatchValidation(translations))
        .getErrors(),
    );
  }
  if (typeForm === DESACTIVE) {
    Object.assign(
      errors,
      new FormValidations(form.pin, 'pin')
        .isValidPin(emptyValidation(translations))
        .getErrors(),
    );
  }
  if (typeForm === MODIFY) {
    Object.assign(
      errors,
      new FormValidations(form.pin_code, 'pin_code')
        .isValidPin(emptyValidation(translations))
        .getErrors(),
    );
  }

  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
};

export const getPropsModalSuccess = (typeForm, translations) => {
  let message = '';
  const resp = {
    modalType: MODAL_SUCCESS,
    props: {},
  };
  if (typeForm === ACTIVE) {
    const msg = getMessage({
      code: 'profile_pin_email_confirm_send',
      message:
        'Te hemos enviado un correo electrónico para confirmar la activación del PIN de Protección.',
      translations: translations
    });
    message = `<p id="message" class="padding-top-2">${msg}</p>`;
  }
  if (typeForm === CHANGE) {
    const msg = getMessage({
      code: 'profile_pin_modify_ok',
      message: 'Se ha modificado correctamente tu PIN.',
      translations: translations

    });
    message = `<p id="message" class="padding-top-2">${msg}</p>`;
  }
  if (typeForm === MODIFY || typeForm === DESACTIVE) {
    const msg = getMessage({
      code: 'profile_pin_modal_modify_ok',
      message: 'Tus modificaciones se han realizado con éxito',
      translations: translations,

    });
    message = `<p id="message" class="padding-top-2">${msg}</p>`;
  }
  if (typeForm === REMIND) {
    const msg = getMessage({
      code: 'profile_pin_remember_email_send',
      message:
        'Te hemos enviado un correo electrónico con tu PIN de Protección.',
      translations: translations,

    });
    message = `<p id="message" class="padding-top-2">${msg}</p>`;
  }
  if (typeForm === SET_PIN) {
    const msg = getMessage({
      code: 'profile_pin_code_modal_active_success',
      message:
        'Tu PIN que de Protección ya está activo. A partir de este momento solicitaremos tu PIN para todos los títulos que tengan la clasificación que elegiste y las rentas y compras que realices. Recuerda que puedes modificar tus preferencias en cualquier momento desde esta sección.',
      translations: translations

    });
    message = `<p id="message" class="padding-top-2">${msg}</p>`;
  }
  resp.props.message = message;
  return resp;
};

export const getPropsModalError = (typeForm, data, translations) => {
  let message = '';
  const resp = {
    modalType: MODAL_ERROR,
    props: {},
  };
  if (
    typeForm === ACTIVE ||
    typeForm === CHANGE ||
    typeForm === MODIFY ||
    typeForm === DESACTIVE
  ) {
    let msg = '';
    if (data.code) msg = getMessage({...data, translations: translations});
    else
      msg = getMessage({
        code: 'profile_pin_modal_code_invalid',
        message: 'El PIN no es correcto. Inténtalo nuevamente',
        translations: translations
      });

    message = `<p id="message" class="padding-top-2">${msg}</p>`;
  }
  if (typeForm === REMIND) {
    const msg = getMessage({...data, translations: translations});
    message = `<p id="message" class="padding-top-2">${msg}</p>`;
  }
  if (typeForm === SET_PIN) {
    const msg = getMessage({...data, translations: translations});
    message = `<p id="message" class="padding-top-2">${msg}</p>`;
  }
  if (typeForm === VALID_EMAIL) {
    const msg = getMessage({...data, translations: translations});
    message = `<p id="message" class="padding-top-2">${msg}</p>`;
  }
  resp.props.message = message;
  return resp;
};
